import template from "./pCasemanTeamClientConfig.html";

export function pCasemanTeamClientConfigDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pCasemanTeamClientConfigController,
    controllerAs: 'pCasemanTeamClientConfig',
    bindToController: true
  };

  return directive;
}

class pCasemanTeamClientConfigController {
  constructor($scope, $location, $interval, $q, Auth, Caseman, Notes, Sort, Utils, ConnectionQuality) {
    'ngInject';
    this.$scope = $scope;
    this.$location = $location;
    this.$interval = $interval;
    this.$q = $q;
    this.Auth = Auth;
    this.Caseman = Caseman;
    this.Notes = Notes;
    this.Sort = Sort;
    this.Utils = Utils;
    this.ConnectionQuality = ConnectionQuality;
    this.state = "loading";
    this.showOnlyActive = true;

    this.headers = [
      {name: "CASEMAN.CLIENT_KLIX", class: "table-info"},
      {name: "CASEMAN.PROJECT_CASEMAN", class: "table-caseman"}
    ];

    this.Auth.authorize().then(
      (user) => {
        this.user = user;
        //Notes...
        const timeout = this.$interval(() => {this.notes = this.Notes.getNotes();}, 200);
        this.$scope.$on("$destroy", () => {this.$interval.cancel( timeout );});

        let promises = [
          this.Caseman.getTeamClients(),
          this.Caseman.getTeamClientMappers()
        ];

        this.$q.all(promises).then(
          (success) => {
            this.clientsKlix = success[0].data.sort(this.Sort.abcBy("name"));
            this.activeClientsKlix = this.clientsKlix.filter(client => client.isActive);
            this.clientsMapper = success[1].data;

            this.mapperToDisplay = this.getMapperToDisplay(this.activeClientsKlix);

            this.state = "loaded";
          },
          (error) => {
            this.state = "error";
            this.Notes.postNote({type: "error", error: error});
          }
        );
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });
  }

  back() {
    window.history.back();
  }

  getMapperToDisplay(klixClients) {
    const mapperToDisplay = klixClients && klixClients.map(clientKlix => {
      let client = this.clientsMapper && this.clientsMapper.find(clientMapper => clientMapper.clientId == clientKlix.id);
      if(!client) {
        client = {
          clientId: clientKlix.id,
          clientName: clientKlix.name,
          projectId: null,
          projectName: null,
          casemanCountry: null,
          unmatched: true
        };
      }
      return client;
    });
    return mapperToDisplay;
  }

  toggleActive() {
    if (this.showOnlyActive) {
      this.mapperToDisplay = this.getMapperToDisplay(this.activeClientsKlix);
    } else {
      this.mapperToDisplay = this.getMapperToDisplay(this.clientsKlix);
    }
  }

}